module.exports = __webpack_public_path__ + "img/Sacha-photo.e3bd5f59.jpg";